module.exports = __webpack_public_path__ + "assets/images/pages/creando/icon-creando-2.png?1f6a9ba5";